import { render, staticRenderFns } from "./cModalAdComment.vue?vue&type=template&id=16390b6b&scoped=true"
import script from "./cModalAdComment.vue?vue&type=script&lang=js"
export * from "./cModalAdComment.vue?vue&type=script&lang=js"
import style0 from "./cModalAdComment.vue?vue&type=style&index=0&id=16390b6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16390b6b",
  null
  
)

export default component.exports